var indentation_default = {
  "indentZero": "logrL",
  "indentOne": "iwS00",
  "indentTwo": "p4LqF",
  "indentThree": "vHxLY",
  "indentFour": "GpD3H",
  "indentFive": "_5WdtI",
  "indentSix": "FwXr7"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
